/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useContext } from 'react';
import { TableCell } from '@blend/alchemy';
import { ActionButton, LoneIconButton, PopoverList } from '@blend/enterprise-components';

import { MeContext } from 'blb-contexts/Me';

import { ActionsCell } from '../styles';

interface MembersAdminActionsProps {
  isTeamAdmin: boolean;
  openEditMemberModal: () => void;
  openRemoveMemberModal: () => void;
  principalId: string;
  teamId: string;
}

const MembersAdminActions: React.FC<MembersAdminActionsProps> = ({
  isTeamAdmin,
  openEditMemberModal,
  openRemoveMemberModal,
  principalId,
  teamId,
}) => {
  const me = useContext(MeContext)!;
  const isSelf = principalId === me.principalId;
  if (isTeamAdmin || isSelf) {
    return (
      <ActionsCell>
        {isTeamAdmin && (
          <ActionButton
            id={`it-edit-member-action-button-${teamId}-${principalId}`}
            label="Edit"
            onClick={openEditMemberModal}
            theme="tertiary"
          />
        )}
        <div>
          {/* wrapped in div because PopoverList inserts an empty div in its parent container which adds an undesirable flex gap */}
          <PopoverList
            anchorPosition="bottom-end"
            buttonConfigs={[
              {
                icon: 'close',
                id: `it-remove-member-${teamId}-${principalId}`,
                key: 'remove-member',
                label: isSelf ? 'Leave team' : 'Remove member',
                onClick: openRemoveMemberModal,
              },
            ]}
          >
            <LoneIconButton
              aria-label="More actions"
              btnSize={36}
              icon="more_horiz"
              iconSize={18}
              id={`it-more-member-actions-${teamId}-${principalId}`}
              theme="tertiary"
            />
          </PopoverList>
        </div>
      </ActionsCell>
    );
  }
  return <TableCell />;
};

export default MembersAdminActions;
